/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardStandingEntry } from './LeaderboardStandingEntry';
import {
    LeaderboardStandingEntryFromJSON,
    LeaderboardStandingEntryFromJSONTyped,
    LeaderboardStandingEntryToJSON,
    LeaderboardStandingEntryToJSONTyped,
} from './LeaderboardStandingEntry';
import type { LeaderboardRegistrantEntry } from './LeaderboardRegistrantEntry';
import {
    LeaderboardRegistrantEntryFromJSON,
    LeaderboardRegistrantEntryFromJSONTyped,
    LeaderboardRegistrantEntryToJSON,
    LeaderboardRegistrantEntryToJSONTyped,
} from './LeaderboardRegistrantEntry';

/**
 * 
 * @export
 * @interface LeaderboardStandingsResponse
 */
export interface LeaderboardStandingsResponse {
    /**
     * 
     * @type {Array<LeaderboardStandingEntry>}
     * @memberof LeaderboardStandingsResponse
     */
    standings: Array<LeaderboardStandingEntry>;
    /**
     * Players who have joined and not scored — no rank and no value, because they have neither. Alphabetical and capped; `registrantsTotal` carries the real count. Page 1 only. Present on a board whose next occurrence has not opened yet (standings empty); empty on a board that is over, whose snapshot records only who competed.
     * @type {Array<LeaderboardRegistrantEntry>}
     * @memberof LeaderboardStandingsResponse
     */
    registrants?: Array<LeaderboardRegistrantEntry>;
    /**
     * How many registrants there are in total, for the "+N more" the cap implies.
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    registrantsTotal?: number;
    /**
     * The CURRENT field size — distinct players with a rankable standing right now (live path) or the snapshot's standings count (historical path). Not all-time enrollees.
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    offset: number;
    /**
     * True when standings come from a snapshot (a board that is over)
     * @type {boolean}
     * @memberof LeaderboardStandingsResponse
     */
    isHistorical?: boolean;
    /**
     * Period number of the snapshot (only when isHistorical)
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    periodNumber?: number;
    /**
     * End timestamp of the snapshot's period (only when isHistorical)
     * @type {number}
     * @memberof LeaderboardStandingsResponse
     */
    periodEndAt?: number;
}

/**
 * Check if a given object implements the LeaderboardStandingsResponse interface.
 */
export function instanceOfLeaderboardStandingsResponse(value: object): value is LeaderboardStandingsResponse {
    if (!('standings' in value) || value['standings'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function LeaderboardStandingsResponseFromJSON(json: any): LeaderboardStandingsResponse {
    return LeaderboardStandingsResponseFromJSONTyped(json, false);
}

export function LeaderboardStandingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardStandingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'standings': ((json['standings'] as Array<any>).map(LeaderboardStandingEntryFromJSON)),
        'registrants': json['registrants'] == null ? undefined : ((json['registrants'] as Array<any>).map(LeaderboardRegistrantEntryFromJSON)),
        'registrantsTotal': json['registrantsTotal'] == null ? undefined : json['registrantsTotal'],
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'isHistorical': json['isHistorical'] == null ? undefined : json['isHistorical'],
        'periodNumber': json['periodNumber'] == null ? undefined : json['periodNumber'],
        'periodEndAt': json['periodEndAt'] == null ? undefined : json['periodEndAt'],
    };
}

export function LeaderboardStandingsResponseToJSON(json: any): LeaderboardStandingsResponse {
    return LeaderboardStandingsResponseToJSONTyped(json, false);
}

export function LeaderboardStandingsResponseToJSONTyped(value?: LeaderboardStandingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'standings': ((value['standings'] as Array<any>).map(LeaderboardStandingEntryToJSON)),
        'registrants': value['registrants'] == null ? undefined : ((value['registrants'] as Array<any>).map(LeaderboardRegistrantEntryToJSON)),
        'registrantsTotal': value['registrantsTotal'],
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'isHistorical': value['isHistorical'],
        'periodNumber': value['periodNumber'],
        'periodEndAt': value['periodEndAt'],
    };
}

